import { Controller } from "stimulus"
import Tooltip from "tooltip.js";

export default class extends Controller {
    connect() {
        var tooltips = Array.from(this.element.querySelectorAll('[data-tooltip]'))

        tooltips.forEach(element => {
            new Tooltip(element, {
                title: element.dataset.tooltip,
                container: 'body'
            })
        })
    }
}
